export default __webpack_public_path__ + "static/media/Balcony1.f20491a3.jpg";